export default __webpack_public_path__ + "static/media/kitchen3-before1-480w.22594f5c.webp";